import { useApiClient } from "@albertine/api-client";
import type { MemberDataFirestoreRecord } from "@albertine/types";
import { SuccessResponsePaymentCustomerSchema } from "@albertine/types/openapi/lmt";
import type { StripeCustomer } from "@prototypes/member-profile/data/profile";

export function useFindStripeCustomer(
    tenant: MemberDataFirestoreRecord["tenant"] | undefined,
    isAdmin: boolean,
) {
    const { apiClient } = useApiClient();

    async function findStripeCustomer(
        stripeCustomerId: string,
    ): Promise<StripeCustomer | null> {
        const trimmed = stripeCustomerId.trim();
        if (!trimmed || !tenant || !isAdmin) return null;

        const response = await apiClient.get.findPaymentCustomer({
            query: { tenant, stripeCustomerId: trimmed },
        });
        const parsed = SuccessResponsePaymentCustomerSchema.safeParse(
            await response.json(),
        );
        if (!parsed.success || !parsed.data.data) return null;

        return {
            id: parsed.data.data.id,
            name: parsed.data.data.name ?? undefined,
            email: parsed.data.data.email ?? undefined,
        };
    }

    return findStripeCustomer;
}
